import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { authSelector } from 'redux/auth/selectors';
import { logoutUser } from 'redux/actions/authActions';
import { setSideBarVisibility } from 'redux/actions/themeActions';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/styles';
import { IconButton, Tooltip, Grid, Typography } from '@material-ui/core';
import Section from 'components/UI/Section';
import { defaultStyles } from 'utils/Theme';
import * as Icon from '@material-ui/icons';
import PropTypes from 'prop-types';
import BookMark from 'components/layout/Partials/Bookmark';
import AccountDropdown from 'components/layout/Partials/AccountDropdown';
import PageDropdown from 'components/layout/Partials/PageDropdown';
import WSUPBgHeader from './WSUPBgHeader';

const Header = ({ qsOptions, title, page }) => {
    const classes = defaultStyles();
    const dispatch = useDispatch();
    const smallDrawerWidth = window.innerWidth > 980 ? 350 : 250;
    const { isAuthenticated } = useSelector(authSelector);
    const { sidebarVisibility } = useSelector((state) => state.theme);

    const handleResize = () => {
        dispatch(setSideBarVisibility(window.innerWidth > 1000 ? true : false));
    };

    const menuToggle = () => {
        dispatch(setSideBarVisibility(!sidebarVisibility));
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
    }, []);

    return (
        <Section className={classes.topBar}>
            <WSUPBgHeader />
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
            >
                <Grid item>
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={1}
                    >
                        <Grid item>
                            <IconButton onClick={menuToggle}>
                                {sidebarVisibility ? (
                                    <Icon.MenuOpen
                                        size={12}
                                        className={classes.colorPrimary}
                                    />
                                ) : (
                                    <Icon.Menu
                                        size={12}
                                        className={classes.colorPrimary}
                                    />
                                )}
                            </IconButton>
                        </Grid>
                        <Grid item>
                            {title ? (
                                <Typography variant="h5" noWrap>
                                    {title}
                                </Typography>
                            ) : null}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid container spacing={1}>
                        {page && (
                            <Grid item>
                                <PageDropdown
                                    page={page}
                                    title={title}
                                    description={page?.description}
                                    id={page?.qsApp}
                                />
                            </Grid>
                        )}
                        <Grid item>
                            <AccountDropdown
                                isAuthenticated={isAuthenticated}
                                logoutUserCallback={() => {
                                    console.info('logging out');
                                    dispatch(logoutUser());
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <BookMark
                                page={page}
                                qsOptions={qsOptions}
                                drawerWidth={smallDrawerWidth}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Section>
    );
};

Header.propTypes = {
    page: PropTypes.object,
    title: PropTypes.string,
    qsOptions: PropTypes.object,
    hideSearchBar: PropTypes.bool,
};
export default Header;
